import {Box, Switch} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {Controller, useFormContext} from '@yandex-delivery/form'
import React from 'react'

import {ExtraItemSlot} from '../desktop'
import {classes} from './CodeConfirmationRequirement.classes'
import {useDefaultTariffRequirements} from './hooks/use-default-tariff-requirements'

export function CodeConfirmationRequirement(): React.ReactElement {
  const t = useI18n()
  const {control} = useFormContext()
  const defaultRequirements = useDefaultTariffRequirements()

  const defaultValue = defaultRequirements.includes('confirmation')

  return (
    <Controller
      control={control}
      defaultValue={defaultValue}
      name="isReturnPointCodeConfirmation"
      render={({field, fieldState}) => (
        <ExtraItemSlot title={t('cargo.create.confirmation-requirement', 'Подтвердить кодом на точке возврата')}>
          <Box className={classes.switch}>
            <Switch error={fieldState.invalid} on={field.value} onChange={field.onChange} size="m" />
          </Box>
        </ExtraItemSlot>
      )}
    />
  )
}
